/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我的优惠券
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class CouponsParams {
  constructor(
    public couponsStatus: "UNUSED" | "EXPIRED" | "USED",
    public pageNum: number,
    public pageSize: number
  ) {}
}

export default async function (
  params: CouponsParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.CouponDetailMessageRes>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/coupons`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
